import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import map from 'lodash/map';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import { Doughnut } from 'react-chartjs-2';
import { browserHistory } from 'react-router';

// eslint-disable-next-line no-unused-vars
import pieceLabel from 'chart.piecelabel.js';

import Filters from '../../shared/filters/main';
import SwitchStats from '../../shared/switch';
import CurrencySwitch from '../../shared/currency-switch';
import Switch from '../../shared/switch';

lessRequire('modules/statistics/analytics/main.less');

const switchStatsLinkConfig = [
	{
		className: 'header-switch__link-stat',
		title: 'Общая',
		url: 'statistics/general/'
	},
	{
		className: 'header-switch__link-goal',
		title: 'Конверсии',
		url: 'statistics/conversions/'
	},
	{
		className: 'header-switch__link-analytics',
		title: 'Аналитика',
		url: 'statistics/analytics/system'
	}
];

const agesLegend = [
	{color: '#d62c2c', title: 'До 20'},
	{color: '#f36ab7', title: '20 - 24'},
	{color: '#833194', title: '25 - 31'},
	{color: '#7d47e9', title: '32 - 36'},
	{color: '#0090ff', title: '37 - 39'},
	{color: '#8d9ff3', title: '40 - 44'},
	{color: '#00dcff', title: '45 - 51'},
	{color: '#488609', title: '52 - 54'},
	{color: '#8caf00', title: '55 - 59'},
	{color: '#a5d500', title: '60 - 64'},
	{color: '#93f5b1', title: '65 - 69'},
	{color: '#f7d038', title: '70 - 74'},
	{color: '#f5a993', title: '75 - 81'},
	{color: '#ff8400', title: 'От 82'}
];

const genAgesData = (d, intl) => {
	return d.showEmptyAgeChart ? {
		labels: [intl('Нет данных')],
		datasets: [{
			data: [1],
			borderWidth: 0,
			backgroundColor: '#f0f0f0'
		}]
	} : {
		labels: map(agesLegend, l => ` ${intl(l.title)}`),
		datasets: [{
			data: [
				d.age_0_19, d.age_20_24, d.age_25_31, d.age_32_36, d.age_37_39, d.age_40_44, d.age_45_51,
				d.age_52_54, d.age_55_59, d.age_60_64, d.age_65_69, d.age_70_74, d.age_75_81, d.age_82
			].map(x => Number(x).toFixed(2)),
			backgroundColor: map(agesLegend, l => l.color),
			borderWidth: 0
		}]
	};
};

const options = d => {
	return {
		responsive: false,
		maintainAspectRatio: false,
		cutoutPercentage: 65,
		title: {display: false},
		legend: {display: false},
		tooltips: {
			enabled: !d.showEmptyAgeChart,
			mode: 'nearest'
		},
		pieceLabel: {
			render: d.showEmptyAgeChart ? 'label' : 'percentage',
			showZero: true,
			fontSize: 16,
			fontFamily: "'ProximaNova-Bold'",
			fontColor: 'white',
			precision: 0
		}
	};
};

const Main = renderViewsState(props => {
	const data = props.dataTable && props.dataTable.tableRows;

	return (<Animate>
		<div className="container">
			<div className="container__content analytics">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">
						{props.intl('Статистика')}
					</h2>
					<SwitchStats links={switchStatsLinkConfig} intl={props.intl} />

					<div className="statistics-position__currency">
						<CurrencySwitch
							listOfCurrencies={props.listOfCurrencies}
							activeCurrency={props.activeCurrency}
							onSwitch={props.changeCurrency} />
					</div>
				</div>
				<div className="container__content-body">
					<div className="stats-wrap__control">
						<Filters {...props} filterApply={props.statisticsFilterApply} />
						<div className="stats-wrap__control-bottom clearfix">
							<button className="submit-btn" onClick={e => props.statsApply()} >{props.intl('Применить')}</button>
						</div>
					</div>
					<div className="doughnut__container">
						<div className="doughnut">
							<Doughnut data={genAgesData(data, props.intl)} options={options(data)} width={360} height={360} />
							<div className="legend">
								<span className="legend-title font-proxima-nova-bold">{props.intl('Возраст')}</span>
								{
									map(agesLegend, l => {
										return (<div className="legend-box" key={l.title}>
											<span className="box" style={{backgroundColor: l.color}} />
											<span className="title">{props.intl(l.title)}</span>
										</div>);
									})
								}
							</div>
							<div className="inner">
								<div className="male">
									<div className="data">
										<span className="value font-proxima-nova-bold">
											{ Math.round(data.male || 0)} %
										</span>
										<span className="title">{props.intl('Мужчин')}</span>
									</div>
								</div>
								<div className="female">
									<div className="data">
										<span className="value font-proxima-nova-bold">
											{ Math.round(data.female || 0)} %
										</span>
										<span className="title">{props.intl('Женщин')}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="analytics-switch-compensate-margin">
						<Switch
							links={[
								{title: 'По моему аккаунту', url: 'statistics/analytics/'},
								{title: 'Общая по системе', url: 'statistics/analytics/system'}
							]}
							onSwitch={link => browserHistory.push(link)}
							intl={props.intl}
						/>
					</div>
				</div>
			</div>
		</div>
	</Animate>);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		dataTable: selectors.getDataTable(state),
		filters: selectors.getFilters(state),
		appliedFilters: selectors.getAppliedFilters(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		listOfCurrencies: selectors.getListOfCurrencies(state),
		activeCurrency: selectors.getActiveCurrency(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/system-analytics/main.js